module.exports = __webpack_public_path__ + "img/bg-c@2x.653eb3d5.png";